module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "contents",
      "src": "images/cont.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_vm._v("introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("chapter I"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("0001–0375 ANIME + MANGA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter II"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("0376–0645 VIDEO GAMES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter III"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("0646–0689 TELEVISION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter IV"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("0690–0781 MOVIES + BOOKS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter V"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("0782–0882 COMIC BOOKS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter VI"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("0883–0981 CUSTOM CHARACTERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter VII"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("0982–1000 PROPS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contri",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("contributor directory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("about the authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee67910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 66
// module chunks = 0